<template>
  <div class="stars-container">
    <canvas id="sparkle_star1" class="animate-flicker"></canvas>
    <canvas id="sparkle_star2" class="animate-flicker-two"></canvas>
  </div>
</template>

<script>

export default {
  name: "SparkleStars",
  data() {
    return {
      cw: 0,
      ch: 0,
      c1: null,
      c2: null,
      ctx1: null,
      ctx2: null,
      twopi: Math.PI * 2,
      parts: [],
      sizeBase: 0,
      opt: null,
      hue: null,
      count: 0,
      fadeI: 0,
      fadeDelta: 0.1,
      image : new Image(),
      fpsInt: 1000 / 5, 
      startTime: null, 
      now: null, 
      then: null, 
      elapsed: null
    }
  },
  mounted() {

    this.c1 = document.getElementById( 'sparkle_star1' ),
    this.ctx1 = this.c1.getContext( '2d' ),
    this.c2 = document.getElementById( 'sparkle_star2' ),
    this.ctx2 = this.c2.getContext( '2d' ),

    this.resize();
    this.create();
    this.loop();

    this.image.src = require('../../assets/imgs/flicker-star.png');
    this.image.onload = () => {
      console.log('image loaded..');
    }
    window.addEventListener( 'resize', this.resize );
  },
	methods: {
    rand( min, max ) {
      return Math.random() * ( max - min ) + min;
    },
    hsla( h, s, l, a ) {
      return 'hsla(' + h + ',' + s + '%,' + l + '%,' + a + ')';
    },
    loop() {
      requestAnimationFrame( this.loop );


    this.now = Date.now();
    this.elapsed = this.now - this.then;
    if (this.elapsed > this.fpsInt) {
      this.then = this.now - (this.elapsed % this.fpsInt);



      this.ctx2.clearRect( 0, 0, this.cw, this.ch );
      this.ctx2.globalCompositeOperation = 'source-over';
      this.ctx2.shadowBlur = 0;
      this.ctx2.drawImage( this.c1, 0, 0 );
      this.ctx2.globalCompositeOperation = 'lighter';

      let i = this.parts.length;
      this.ctx2.shadowBlur = 15;
      this.ctx2.shadowColor = '#fff';
      while( i-- ) {
        let part = this.parts[ i ];

        part.x += Math.cos( part.angle ) * part.vel;
        part.y += Math.sin( part.angle ) * part.vel;
        part.angle += this.rand( -0.05, 0.05 );

        // this.ctx2.beginPath();
        this.ctx2.arc( part.x, part.y, part.radius, 0, this.twopi );
        // this.ctx2.fillStyle = this.hsla( 0, 0, 100, 0.075 + Math.cos( part.tick * 0.02 ) * 0.05 );
        // this.ctx2.fill();

        this.ctx2.drawImage(this.image, part.x, part.y);

        this.fadeI += this.fadeDelta;
        
        if ( this.fadeI <= 0.2 ) {
            this.fadeDelta = -this.fadeDelta;
            this.fadeI = 0.2;
        } else if ( this.fadeI >= 0.7 ) {
            this.fadeDelta = -this.fadeDelta;
            this.fadeI = 0.7;
        }


        this.ctx2.globalAlpha = this.fadeI;

        // if( part.x - part.radius > this.cw ) { part.x = -part.radius }
        // if( part.x + part.radius < 0 )  { part.x = this.cw + part.radius }
        // if( part.y - part.radius > this.ch ) { part.y = -part.radius }
        // if( part.y + part.radius < 0 )  { part.y = this.ch + part.radius }

        part.tick++;
      }
    }
    },
    resize() {
      this.cw = this.c1.width = this.c2.width = window.innerWidth,
      this.ch = this.c1.height = this.c2.height = window.innerHeight;
    },
    create() {
      this.sizeBase = this.cw + this.ch;
      this.count = Math.floor( this.sizeBase * 0.3 ),
      this.hue = this.rand( 0, 360 ),
      this.opt = {
        radiusMin: 1,
        radiusMax: this.sizeBase * 0.04,
        blurMin: 10,
        blurMax: this.sizeBase * 0.04,
        hueMin: hue,
        hueMax: hue + 100,
        saturationMin: 10,
        saturationMax: 70,
        lightnessMin: 20,
        lightnessMax: 50,
        alphaMin: 0.1,
        alphaMax: 0.5
      }
      this.ctx1.clearRect( 0, 0, this.cw, this.ch );
      this.ctx1.globalCompositeOperation = 'lighter';
      while( this.count-- ) {
        var radius = this.rand( this.opt.radiusMin, this.opt.radiusMax ),
        x = this.rand( 0, this.cw ),
        y = this.rand( 0, this.ch ),
        hue = this.rand(this.opt.hueMin, this.opt.hueMax );
        this.ctx1.beginPath();
        this.ctx1.arc( x, y, radius, 0, this.twopi );
        this.ctx1.closePath();
      }

      this.parts.length = 0;
      console.log('how many', Math.floor( ( this.cw + this.ch ) * 0.03 ));
      for( var i = 0; i < Math.floor( ( this.cw + this.ch ) * 0.03 ); i++ ) {
        this.parts.push({
          radius: this.rand( 1, this.sizeBase * 0.03 ),
          x: this.rand( 0, this.cw ),
          y: this.rand( 0, this.ch / 3),
          angle: this.rand( 0, this.twopi ),
          vel: 0.5,
          tick: this.rand( 0, 100000 )
        });
      }
    }
	}
}
</script>
<style scoped lang="scss">

.stars-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100vh;
    pointer-events: none;
    overflow: hidden;
    canvas {
      bottom: 0;
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
    }
}

// @keyframes flickerAnimation {
//   0%   { opacity:1; }
//   50%  { opacity:0.5; }
//   100% { opacity:1; }
// }
// .animate-flicker {
//     animation: flickerAnimation 1.5s infinite;
// }

// @keyframes flickerAnimation2 {
//   0%   { opacity:1; }
//   50%  { opacity:0.5; }
//   100% { opacity:1; }
// }
.animate-flicker-two {
    animation: flickerAnimation2 2.5s infinite;
}
</style>
